import './index.css'
/*
 * InterstitialPage Base Js
 */
;(function () {
  let InterstitialPage = {}
  InterstitialPage.timeLeft = 6
  InterstitialPage.timeinterval = 1000
  InterstitialPage.timeout = 6000
  InterstitialPage.redirectTimeout = null
  InterstitialPage.errorMessage =
    window.Interstitial && window.Interstitial.error
  InterstitialPage.redirectUrl =
    window.Interstitial && window.Interstitial.redirect
  InterstitialPage.canRedirectHappen = true
  InterstitialPage.countDownElement = document.getElementById(
    'interstitial-countdown'
  )
  InterstitialPage.continue = document.getElementById('exLink-continue')
  InterstitialPage.cancel = document.getElementById('exLink-cancel')
  InterstitialPage.autoRedirect = () => {
    if (InterstitialPage.redirectTimeout) {
      clearTimeout(InterstitialPage.redirectTimeout)
      clearInterval(InterstitialPage.countDownInterval)
    }
    window.location.href = InterstitialPage.redirectUrl
  }
  InterstitialPage.registerEvents = () => {
    InterstitialPage.continue &&
      InterstitialPage.continue.addEventListener('click', event => {
        event.preventDefault()
        if (InterstitialPage.redirectTimeout) {
          clearTimeout(InterstitialPage.redirectTimeout)
          clearInterval(InterstitialPage.countDownInterval)
        }
        if (InterstitialPage.canRedirectHappen) {
          InterstitialPage.canRedirectHappen = false
          const targetUrl = event.currentTarget.getAttribute('href')
          window.location.href = targetUrl
        }
      })
    InterstitialPage.cancel &&
      InterstitialPage.cancel.addEventListener('click', event => {
        event.preventDefault()
        InterstitialPage.canRedirectHappen = false
        if (InterstitialPage.redirectTimeout) {
          clearInterval(InterstitialPage.countDownInterval)
          clearTimeout(InterstitialPage.redirectTimeout)
        }
        InterstitialPage.continue &&
          InterstitialPage.continue.setAttribute('disabled', 'disabled')
        InterstitialPage.cancel &&
          InterstitialPage.cancel.setAttribute('disabled', 'disabled')
        window.close()
      })
    InterstitialPage.countDownInterval = setInterval(() => {
      if (InterstitialPage.timeLeft < 0) {
        clearInterval(InterstitialPage.countDownInterval)
      } else {
        InterstitialPage.timeLeft--
        InterstitialPage.countDownElement.innerHTML = InterstitialPage.timeLeft
      }
    }, InterstitialPage.timeinterval)
    InterstitialPage.redirectTimeout = setTimeout(() => {
      if (InterstitialPage.canRedirectHappen) {
        InterstitialPage.autoRedirect()
      }
    }, InterstitialPage.timeout)
  }

  document.addEventListener('DOMContentLoaded', () => {
    InterstitialPage.registerEvents()
  })
})()
